module.exports = __webpack_public_path__ + "static/media/2.da95116d.svg";